import { HttpService } from '@/http-services/http.service';
import { DeviceInfo } from '@capacitor/device';
import { AxiosError } from 'axios';
import { LoginRequest, LoginResponse, RefreshTokenRequest } from 'common';

export class AuthService extends HttpService {
  async login(
    usernameOrEmail: string,
    password: string,
    opts?: { deviceId?: string; deviceInfo?: DeviceInfo; appVersion?: string }
  ): Promise<LoginResponse> {
    const isEmail = usernameOrEmail.includes('@');
    const body: LoginRequest = {
      username: isEmail ? undefined : usernameOrEmail,
      email: isEmail ? usernameOrEmail : undefined,
      password,
      deviceId: opts?.deviceId,
    };
    if (opts?.deviceInfo && opts?.appVersion) {
      body.userMobileDeviceStats = {
        operatingSystem: opts.deviceInfo.operatingSystem,
        osVersion: opts.deviceInfo.osVersion,
        appVersion: opts.appVersion,
        deviceModel: opts.deviceInfo.model,
        manufacturer: opts.deviceInfo.manufacturer,
        lastUsed: new Date(),
      };
    }
    const res = this.send<LoginResponse>({
      url: '/Login',
      data: body,
      method: 'post',
    }).catch((e) => {
      return e instanceof AxiosError && e.response?.data
        ? (e.response.data as LoginResponse)
        : ({
            success: false,
            message: 'Failed to login',
          } as LoginResponse);
    });

    return res;
  }

  refreshToken(
    usernameOrEmail: string,
    deviceId: string,
    refreshToken: string,
    opts?: { appVersion?: string; deviceInfo?: DeviceInfo }
  ) {
    const isEmail = usernameOrEmail.includes('@');
    const body: RefreshTokenRequest = {
      username: isEmail ? undefined : usernameOrEmail,
      email: isEmail ? usernameOrEmail : undefined,
      deviceId,
      refreshToken,
    };
    if (opts?.deviceInfo && opts.appVersion) {
      body.userMobileDeviceStats = {
        operatingSystem: opts.deviceInfo.operatingSystem,
        osVersion: opts.deviceInfo.osVersion,
        appVersion: opts.appVersion,
        deviceModel: opts.deviceInfo.model,
        manufacturer: opts.deviceInfo.manufacturer,
        lastUsed: new Date(),
      };
    }
    return this.send<LoginResponse>({
      url: '/RefreshToken',
      data: body,
      method: 'post',
      headers: {
        'x-no-retry': 'true',
      },
    });
  }
}
